@if (isEmptyList && insight.emptyText) {
  <p class="profile-insight-answer__empty"><i class="fal fa-circle-minus" aria-hidden="true"></i>{{ insight.emptyText }}</p>
} @else if (['pills', 'labelled_pills', 'string_list'].includes(insight.displayType)) {
  <ul class="profile-insight-list" [class.profile-insight-list--pills]="insight.displayType === 'pills'">
    @for (item of visible(items, listLimit); track $index) {
      <li>
        <span class="profile-insight-list__marker" aria-hidden="true"><i class="fal" [ngClass]="insight.displayType === 'labelled_pills' ? 'fa-check' : insight.displayType === 'pills' ? 'fa-tag' : 'fa-circle'"></i></span>
        <span class="profile-insight-list__copy">{{ listText(item, insight.schema) }}
          @if (listDetail(item, insight.schema); as detail) {<small>{{ detail }}</small>}
        </span>
      </li>
    }
  </ul>
  @if (!expanded && items.length > listLimit) {
    <button class="profile-insight-list__toggle" type="button" [attr.aria-expanded]="listExpanded" (click)="toggleList()">
      {{ listExpanded ? 'Show fewer' : 'Show all ' + items.length }}
      <i class="fal" [ngClass]="listExpanded ? 'fa-chevron-up' : 'fa-chevron-down'" aria-hidden="true"></i>
    </button>
  }
} @else { @switch (insight.displayType) {
  @case ('vertical_bar_chart') {<aira-bar-chart [label]="''" [schema]="insight.schema" [data]="insight.value" [colours]="chartColours" [height]="205" />}
  @case ('pie_chart') {<aira-pie-chart [label]="''" [data]="insight.categoryChart?.data || insight.value" [labelName]="insight.categoryChart ? 'label' : insight.schema.label_name" [valueName]="insight.categoryChart ? 'value' : insight.schema.value_name" [append]="insight.categoryChart?.valueSuffix || insight.schema.append" [total]="insight.schema.total" [baseLabel]="insight.schema.base_number_label" [remainderLabel]="insight.schema.remainder_number_label" [totalLabelOverride]="insight.categoryChart ? 'reported' : null" [totalCountOverride]="insight.categoryChart?.reportedCount" [colours]="chartColours" [width]="275" />}
  @case ('gauge') {<aira-gauge [label]="''" [value]="insight.value" [maximumValue]="insight.schema.maximum_value" [height]="205" [colours]="[gaugeColour]" />}
  @case ('card_list') {<aira-card-list [schema]="insight.schema" [data]="insight.value" [headerKeyName]="insight.schema.header_key_name" [contentKeyName]="insight.schema.content_key_name" [headerWordLimit]="1000" [headerTextColor]="cardListHeaderColour" />}
  @case ('number') {<div class="profile-insight-answer__metric">{{ insight.schema.prepend || '' }}{{ valueText(insight.value) }}<small>{{ insight.schema.append || '' }}</small></div>}

  @case ('likelihood') {
    @if (likelihood; as meter) {
      <div class="profile-insight-likelihood">
        <div class="profile-insight-likelihood__figure"><strong>{{ meter.label }}</strong>@if (meter.band) {<span>{{ meter.band }}</span>}</div>
        <div class="profile-insight-likelihood__track" role="meter" aria-valuemin="0" aria-valuemax="100" [attr.aria-valuenow]="meter.percent" [attr.aria-label]="insight.title + ': ' + meter.label + (meter.band ? ', ' + meter.band.toLowerCase() : '')">
          <span [style.width.%]="meter.percent"></span>
        </div>
        <div class="profile-insight-likelihood__scale" aria-hidden="true"><span>0%</span><span>50%</span><span>100%</span></div>
      </div>
    } @else {<p class="profile-insight-answer__empty"><i class="fal fa-circle-minus" aria-hidden="true"></i>No likelihood estimated</p>}
  }
  @case ('amount') {
    <div class="profile-insight-amount" [class.profile-insight-amount--muted]="amount.note === 'No value estimated' || amount.value === '—'">
      <strong>{{ amount.value }}@if (amount.unit) {<small>{{ amount.unit }}</small>}</strong>
      @if (amount.note) {<span>{{ amount.note }}</span>}
    </div>
  }
  @case ('records') {
    <ul class="profile-insight-records">
      @for (record of visible(records, listLimit); track $index) {
        <li [class.profile-insight-records__item--lead]="!!record.lead">
          @if (record.lead) {<span class="profile-insight-records__lead">{{ record.lead }}</span>}
          <div class="profile-insight-records__copy">
            <div class="profile-insight-records__title">
              @if (record.flag) {<span class="flag-icon profile-insight-records__flag" [ngClass]="'flag-icon-' + record.flag" aria-hidden="true"></span>}
              <strong>{{ record.title }}</strong>
              @if (record.amount) {<span class="profile-insight-records__amount">{{ record.amount }}</span>}
            </div>
            @if (record.body) {<p>{{ record.body }}</p>}
            @if (record.meta.length) {<small>{{ record.meta.join(' · ') }}</small>}
          </div>
        </li>
      }
    </ul>
    @if (!expanded && records.length > listLimit) {
      <button class="profile-insight-list__toggle" type="button" [attr.aria-expanded]="listExpanded" (click)="toggleList()">
        {{ listExpanded ? 'Show fewer' : 'Show all ' + records.length }}
        <i class="fal" [ngClass]="listExpanded ? 'fa-chevron-up' : 'fa-chevron-down'" aria-hidden="true"></i>
      </button>
    }
  }
  @case ('chips') {
    <ul class="profile-insight-chips">
      @for (item of visible(items, chipLimit); track $index) {<li>{{ listText(item, insight.schema) }}</li>}
    </ul>
    @if (!expanded && items.length > chipLimit) {
      <button class="profile-insight-list__toggle" type="button" [attr.aria-expanded]="listExpanded" (click)="toggleList()">
        {{ listExpanded ? 'Show fewer' : 'Show all ' + items.length }}
        <i class="fal" [ngClass]="listExpanded ? 'fa-chevron-up' : 'fa-chevron-down'" aria-hidden="true"></i>
      </button>
    }
  }
  @case ('notes') {
    <ul class="profile-insight-notes">
      @for (item of visible(items, listLimit); track $index) {
        <li><span>{{ listText(item, insight.schema) }}</span>@if (noteDetail(item, insight.schema); as detail) {<small>{{ detail }}</small>}</li>
      }
    </ul>
    @if (!expanded && items.length > listLimit) {
      <button class="profile-insight-list__toggle" type="button" [attr.aria-expanded]="listExpanded" (click)="toggleList()">
        {{ listExpanded ? 'Show fewer' : 'Show all ' + items.length }}
        <i class="fal" [ngClass]="listExpanded ? 'fa-chevron-up' : 'fa-chevron-down'" aria-hidden="true"></i>
      </button>
    }
  }
  @case ('bars') {
    <ul class="profile-insight-bars">
      @for (bar of bars; track $index) {
        <li [class.profile-insight-bars__item--empty]="bar.empty"><span class="profile-insight-bars__label">{{ bar.label }}</span><span class="profile-insight-bars__track" aria-hidden="true"><span [style.width.%]="bar.percent"></span></span><strong>{{ bar.value }}</strong></li>
      }
    </ul>
  }
  @case ('breakdown') {
    <ul class="profile-insight-bars profile-insight-bars--stacked">
      @for (bar of visible(bars, 6); track $index) {
        <li><span class="profile-insight-bars__label">{{ bar.label }}</span><strong>{{ bar.value }}</strong><span class="profile-insight-bars__track" aria-hidden="true"><span [style.width.%]="bar.percent"></span></span></li>
      }
    </ul>
  }
  @case ('text') {
    @if (isStatement) {<p class="profile-insight-answer__statement">{{ text }}</p>}
    @else {
      <p #textBlock class="profile-insight-answer__text" [class.profile-insight-answer__text--clamped]="!expanded && !textExpanded">{{ text }}</p>
      @if (!expanded && (textOverflows || textExpanded)) {
        <button class="profile-insight-list__toggle" type="button" [attr.aria-expanded]="textExpanded" (click)="textExpanded = !textExpanded">
          {{ textExpanded ? 'Show less' : 'Read full summary' }}
          <i class="fal" [ngClass]="textExpanded ? 'fa-chevron-up' : 'fa-chevron-down'" aria-hidden="true"></i>
        </button>
      }
    }
  }
  @default {<p class="profile-insight-answer__summary">{{ valueText(insight.value) }}</p>}
}}
